import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing, Check, Phone } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

const formatDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("tr-TR");
const hasValue = (v) => v && v.trim() && v.trim() !== "-";

const ReminderRow = ({ item, today, onDone }) => {
  const overdue = item.note_reminder_date < today;
  const isToday = item.note_reminder_date === today;
  const tone = overdue ? "border-red-200 bg-red-50" : isToday ? "border-amber-300 bg-amber-50" : "border-gray-200 bg-white";
  return (
    <div className={`flex items-start justify-between gap-3 p-3 border rounded-lg ${tone}`} data-testid={`note-reminder-${item.id}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-medium text-sm text-gray-900">
            {hasValue(item.serial_number) ? `#${item.serial_number} - ` : ""}{item.name} {item.surname}
          </span>
          <span className={`text-xs font-semibold ${overdue ? "text-red-700" : isToday ? "text-amber-700" : "text-gray-600"}`}>
            {formatDate(item.note_reminder_date)}{overdue ? " • Gecikti" : isToday ? " • Bugün" : ""}
          </span>
        </div>
        <p className="text-xs text-gray-700 mt-1 whitespace-pre-wrap break-words">{item.notes || "(Not yok)"}</p>
        {hasValue(item.phone) && (
          <a href={`tel:${item.phone}`} className="inline-flex items-center gap-1 text-xs text-blue-600 hover:underline mt-1">
            <Phone className="h-3 w-3" /> {item.phone}
          </a>
        )}
      </div>
      <Button size="sm" variant="outline" onClick={() => onDone(item)} title="Hatırlatmayı tamamla" data-testid={`note-reminder-done-${item.id}`}>
        <Check className="h-4 w-4" />
      </Button>
    </div>
  );
};

export const UpcomingNoteReminders = ({ api, sessionToken }) => {
  const [data, setData] = useState({ reminders: [], today: "" });

  const load = async () => {
    try {
      const res = await axios.get(`${api}/note-reminders/upcoming`, { params: { session_token: sessionToken, days: 7 } });
      setData(res.data);
    } catch (e) {
      console.error("Not hatırlatmaları alınamadı:", e);
    }
  };

  useEffect(() => { if (sessionToken) load(); }, [sessionToken]);

  const markDone = async (item) => {
    try {
      await axios.patch(`${api}/customers/${item.id}/notes`, { note_reminder_date: "" }, { params: { session_token: sessionToken } });
      toast.success("Hatırlatma tamamlandı");
      load();
    } catch (e) {
      toast.error("Hatırlatma güncellenemedi");
    }
  };

  if (!data.reminders.length) return null;
  return (
    <Card className="border-amber-200" data-testid="upcoming-note-reminders">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <BellRing className="h-5 w-5 text-amber-600" />
          Yaklaşan Notlar
          <span className="text-xs font-normal text-gray-500">(geciken + önümüzdeki 7 gün, {data.reminders.length} adet)</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {data.reminders.map((item) => (
          <ReminderRow key={item.id} item={item} today={data.today} onDone={markDone} />
        ))}
      </CardContent>
    </Card>
  );
};
